import { render } from "./lentControl.vue?vue&type=template&id=7252b174&scoped=true"
import script from "./lentControl.vue?vue&type=script&lang=js"
export * from "./lentControl.vue?vue&type=script&lang=js"

import "./lentControl.vue?vue&type=style&index=0&id=7252b174&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7252b174"]])

export default __exports__